import { render, staticRenderFns } from "./InformationDetailView.vue?vue&type=template&id=327ed812&"
import script from "./InformationDetailView.vue?vue&type=script&lang=ts&"
export * from "./InformationDetailView.vue?vue&type=script&lang=ts&"
import style0 from "./InformationDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports